<template>
  <ChatAttachment
    v-if="tooBig || !url"
    v-bind="attachment"
    class="bg-white"
    downloadable
    hide-remove
  />

  <div v-else-if="url" ref="img" class="chat-attachment-image" @click="open">
    <img :src="url" :alt="filename" @load="$emit('load', $refs.img)" />
  </div>
</template>

<script>
import API from "@/api";

import ChatAttachment from "./ChatAttachment";

export default {
  components: {
    ChatAttachment
  },

  props: {
    attachment: Object,
    id: Number,
    filename: String,
    size: Number
  },

  data: () => ({
    loadedAt: null,
    url: null
  }),

  computed: {
    tooBig() {
      return this.size > 10 * 1024 ** 2; // 10 MB
    }
  },

  mounted() {
    this.load();
  },

  methods: {
    async getUrl() {
      // aws signed url expires in 15 minutes
      if (this.loadedAt && Date.now() - this.loadedAt < 1000 * 900) {
        return this.url;
      }

      this.loadedAt = Date.now();
      const r = await API.getChatAttachmentUrl(this.id);
      if (!r.success) {
        return this.$notify({
          type: "error",
          text: r.error.message
        });
      }

      return r.results;
    },

    async load() {
      if (this.tooBig) return;
      const url = await this.getUrl();
      const img = new Image();
      img.src = url;
      img.onload = () => {
        this.url = url;
      };
    },

    async open() {
      const url = await this.getUrl();
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="scss">
.chat-attachment-image {
  max-width: min(80%, 40em);
  border-radius: 4px;
  overflow: hidden;
  cursor: zoom-in;
}
</style>
